/**
 * Analytics consent state (self-hosted replacement for Termly's consent manager).
 * Only first-party analytics (journeyTracker) is gated on this — auth tokens and
 * user preferences are strictly-necessary storage and not consent-controlled.
 */

const CONSENT_KEY = 'qa_consent'; // 'accepted' | 'declined' | null (undecided)

export const CONSENT_CHANGE_EVENT = 'qa-consent-change';
export const CONSENT_OPEN_EVENT = 'qa-consent-open';

export function getConsent() {
  try {
    return localStorage.getItem(CONSENT_KEY);
  } catch {
    return null;
  }
}

export function setConsent(value) {
  try {
    localStorage.setItem(CONSENT_KEY, value);
  } catch {
    // Storage unavailable (private mode) — still broadcast so the session honors the choice
  }
  window.dispatchEvent(new CustomEvent(CONSENT_CHANGE_EVENT, { detail: value }));
}

// Re-opens the consent banner (footer "Consent Preferences" link)
export function openConsentPreferences() {
  window.dispatchEvent(new Event(CONSENT_OPEN_EVENT));
}
